<footer>
    <div class="foo-link" *ngIf="!hideFooterMenu">
      <ul class="list-inline">
        <li class="list-inline-item"><a href="https://home.kpmg/sg/en/home/misc/privacy.html" target="_blank">Privacy</a></li>
        <li class="list-inline-item"><a class="hand-cursor" (click)="redirectToContactUs()">Contact Us</a></li>
        <li class="list-inline-item"><a href="https://home.kpmg/sg/en/home/misc/legal.html" target="_blank">Legal</a></li>
        <li class="list-inline-item"><a class="hand-cursor" (click)="redirectToTermsAndConditions()">Terms and Conditions</a></li>
        <li class="list-inline-item"><a class="hand-cursor" (click)="redirectToAboutUs()">About Us</a></li>
        <li *ngIf="!isPostLogin" class="list-inline-item"><a class="hand-cursor" (click)="redirectToFAQ()">FAQs</a></li>
      </ul>
    </div>
    <div class="copy-info">
      © {{year}} KPMG Services Pte. Ltd. (Registration No: 200003956G), a Singapore incorporated company and a member firm
      of the KPMG global organization <br /> of independent member firms affiliated with KPMG International Limited,
      a private English company limited by guarantee. All rights reserved.
    </div>
</footer>
